export default "__VITE_ASSET__DAZlfiBt__"